import axios, {AxiosRequestConfig} from 'axios';
import {Auth} from "aws-amplify";
import {CognitoUserSession} from "amazon-cognito-identity-js";
import stageParameters from "../constants/env";


export const getCities = async (stage: string) => {
    const requestConfig: AxiosRequestConfig = {
        method: 'get',
        timeout: 60000,
        baseURL: `https://${stageParameters[stage].gwUrl}`,
        headers: {
            'Content-Type': 'application/json',
        }

    };

    const session: CognitoUserSession = await Auth.currentSession();

    requestConfig.headers.Authorization = session.getIdToken().getJwtToken();
    requestConfig.url = `/getCities`;

    return axios(requestConfig);
};
